import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatTabsModule } from '@angular/material/tabs';
import { SharedModule } from '@modules/shared.module';
import { UiGridResetModule } from '@pages/generics/grid/grid-reset';
import { RolesPageComponent } from '@pages/roles/roles.page';
import { UiGridModule } from '@uipath/angular/components/ui-grid';
import { UiAutofocusModule } from '@uipath/angular/directives/ui-autofocus';
import { UiContentLoaderModule } from '@uipath/angular/directives/ui-content-loader';
import { UiNgLetModule } from '@uipath/angular/directives/ui-ng-let';
import { UiScrollIntoViewModule } from '@uipath/angular/directives/ui-scroll-into-view';
import { UiSpinnerButtonModule } from '@uipath/angular/directives/ui-spinner-button';

import { RoleUsersGridComponent } from './grids';
import {
    RoleModalComponent,
    RoleUsersModalComponent,
} from './modals';

const MODALS = [
    RoleModalComponent,
    RoleUsersModalComponent,
];

@NgModule({
    imports: [
        CommonModule,
        SharedModule,
        UiGridModule,
        UiGridResetModule,
        MatExpansionModule,
        UiAutofocusModule,
        UiScrollIntoViewModule,
        UiNgLetModule,
        UiSpinnerButtonModule,
        UiContentLoaderModule,
        MatTabsModule,
    ],
    declarations: [
        RoleUsersGridComponent,
        RolesPageComponent,
        ...MODALS,
    ],
    exports: [
        RolesPageComponent,
    ],
    entryComponents: [
        ...MODALS,
    ],
})
export class RoleModule { }
